export const transitions = {
  duration: {
    shortest: "0.125s",
    shorter: "0.165s",
    short: "0.21s",
    standard: "0.25s",
  },
};
